import React, { useEffect, useState } from "react";
import * as finService from "../../../services/finService";
import { AppDropdown, inputStyle } from "../../../components/ui";

// Picks an account combination as { QUALIFIER: value }. The account comes from a searchable list
// (number - description); the company is the ledger's; every other segment shows its default
// until "More" opens it. The API fills defaults for segments left out and validates the result.
const cache = {};
async function accountValues(valueSetId) {
  if (!cache[valueSetId]) {
    cache[valueSetId] = finService
      .listMaster("segment-values", { value_set_id: valueSetId, status: "ACTIVE" })
      .then((res) => (res?.data || []).filter((v) => !v.is_parent && v.allow_posting).map((v) => ({ label: `${v.value} – ${v.description}`, value: v.value, description: v.control_account && v.control_account !== "NONE" ? `${v.control_account} control account` : undefined })))
      .catch(() => []);
  }
  return cache[valueSetId];
}
export const resetAccountCache = () => Object.keys(cache).forEach((k) => delete cache[k]);

export default function AccountPicker({ structure, companyValue, value, onChange, disabled, id }) {
  const [options, setOptions] = useState([]);
  const [more, setMore] = useState(false);
  const acctSeg = structure ? structure.segments.find((s) => s.qualifier === "ACCOUNT") : null;
  const others = structure ? structure.segments.filter((s) => !["COMPANY", "ACCOUNT"].includes(s.qualifier)) : [];
  const v = value || {};

  useEffect(() => {
    let alive = true;
    if (acctSeg) accountValues(acctSeg.value_set_id).then((o) => alive && setOptions(o));
    return () => {
      alive = false;
    };
  }, [acctSeg]);

  const set = (patch) => onChange({ COMPANY: companyValue, ...v, ...patch });
  const changed = others.filter((s) => v[s.qualifier] && v[s.qualifier] !== s.default_value);

  return (
    <div>
      <AppDropdown id={id} value={v.ACCOUNT || null} options={options} onChange={(e) => set({ ACCOUNT: e.value })} placeholder="Account" filter disabled={disabled} />
      {others.length ? (
        <button type="button" onClick={() => setMore((m) => !m)} disabled={disabled} style={{ background: "none", border: "none", padding: "2px 0", fontSize: 12, color: "#C0335A", cursor: "pointer" }}>
          {more ? "Fewer segments" : changed.length ? `${changed.map((s) => `${s.name} ${v[s.qualifier]}`).join(", ")} · change` : "More segments"}
        </button>
      ) : null}
      {more ? (
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(110px, 1fr))", gap: 6, marginTop: 4 }}>
          {others.map((s) => (
            <input
              key={s.qualifier}
              className="form-control"
              style={{ ...inputStyle, height: 34, fontSize: 13 }}
              aria-label={s.name}
              title={s.name}
              placeholder={`${s.name} (${s.default_value || "required"})`}
              value={v[s.qualifier] || ""}
              disabled={disabled}
              onChange={(e) => set({ [s.qualifier]: e.target.value.toUpperCase() })}
            />
          ))}
        </div>
      ) : null}
    </div>
  );
}

// The account object back from a journal line's concatenated account string.
export function accountFromString(structure, concatenated) {
  if (!structure || !concatenated) return {};
  const parts = String(concatenated).split(structure.delimiter || "-");
  const out = {};
  structure.segments.forEach((s, i) => (out[s.qualifier] = parts[i]));
  return out;
}
